module.exports = __webpack_public_path__ + "img/img1.2282c4a6.jpg";